import {z} from 'zod';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {optionItemSchema} from '../common/OptionItemSchema';

const fileItemSchema = z.object({
  fileId: z.string(),
  fileName: z.string(),
});

export type FileItem = z.infer<typeof fileItemSchema>;

const zipItemSchema = z.object({
  zipId: z.string(),
  fileName: z.string(),
});

export type ZipItem = z.infer<typeof zipItemSchema>;

export const extractDeliveryNoteDocumentRequestSchema = z
  .object({
    files: z.array(fileItemSchema).optional(),
    zips: z.array(zipItemSchema).optional(),
    suppliers: z.array(optionItemSchema),
    units: z.array(optionItemSchema),
    vat: z.array(optionItemSchema),
  })
  .refine((data) => isNotNilOrEmpty(data.files) || isNotNilOrEmpty(data.zips), {
    message: 'At least one of files or zips must be provided',
  });

export type ExtractDeliveryNoteDocumentRequest = z.infer<
  typeof extractDeliveryNoteDocumentRequestSchema
>;
